module.exports = __webpack_public_path__ + "media/img/patterns/grid-horizontal-rtl-long-light-c6102437ade3f886aae3bd48c2a24274.png";